/** Build-time default (used until runtime config is loaded, if ever). */
const BUILD_DEFAULT_API_BASE =
  import.meta.env.VITE_API_BASE ??
  (import.meta.env.PROD ? 'http://192.168.1.100:8080/gm' : 'http://localhost:8081');

let apiBase = BUILD_DEFAULT_API_BASE;

export const BASE_URL = import.meta.env.PROD ? (import.meta.env.BASE_URL || '/') : '/';

/** Current API base URL (can be overridden at runtime via /config.json). */
export function getApiBase(): string {
  return apiBase;
}

/** Set API base URL (called after loading runtime config). */
export function setApiBase(base: string): void {
  if (base != null && typeof base === 'string' && base.trim() !== '') {
    apiBase = base.replace(/\/+$/, '');
  }
}

/** @deprecated Use getApiBase() for dynamic value. Kept for backward compatibility. */
export const API_BASE = BUILD_DEFAULT_API_BASE;

export interface RuntimeConfig {
  apiBase?: string;
}

/**
 * Load runtime config from /config.json (optional).
 * Call this before the first API request so the base URL can be overridden without rebuilding.
 * Place config.json in public/ (dev) or serve it at /config.json (e.g. Docker volume).
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const res = await fetch(`${origin}/config.json`, { cache: 'no-store' });
    if (!res.ok) return {};
    const data = (await res.json()) as RuntimeConfig;
    if (data.apiBase) setApiBase(data.apiBase);
    return data;
  } catch {
    return {};
  }
}
